<script setup lang="ts">
  import type { RefComponent } from '@/types'

  import { ref } from 'vue'

  import TheManagerHeader from '@/layouts/TheManagerLayout/TheManagerHeader.vue'
  import TheManagerFooter from '@/layouts/TheManagerLayout/TheManagerFooter.vue'
  import TheManagerSidebar from '@/layouts/TheManagerLayout/TheManagerSidebar.vue'

  import ManagerToast from '@/components/Global/Manager/ManagerToast.vue'

  const sidebarMenu: RefComponent<typeof TheManagerSidebar> = ref(null)
</script>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'TheManagerLayout',
  })
</script>

<template>
  <div class="manager-page bg-mbg">
    <!-- Header -->
    <TheManagerHeader :show-sidebar-menu="sidebarMenu?.show" />
    <!-- Sidebar menu -->
    <TheManagerSidebar ref="sidebarMenu" />
    <!-- Page Content -->
    <main>
      <slot />
    </main>
    <!-- Footer -->
    <TheManagerFooter />
  </div>

  <ManagerToast />
</template>
